"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
const servicesLinks = [{
  title: "מטפל סיעודי",
  url: "/HomePage"
}, {
  title: "מטפל סיעודי בתל אביב",
  url: "/NurseInTelAvivWithinHoursPage"
}, {
  title: "פתרון מיידי תוך 5 שעות",
  url: "/NursingCareInCityImmediateSolutionWithinFiveHoursPage"
}];
const locations1 = [{
  title: "חיפה והסביבה",
  url: "/NursingCareProviderInHaifaWithinHoursPage"
}, {
  title: "תל אביב",
  url: "/NurseInTelAvivWithinHoursPage"
}, {
  title: "רמת גן",
  url: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  title: "ירושלים",
  url: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  title: "פתח תקווה",
  url: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "ראשון לציון",
  url: "/NursingCaregiverInRishonLeZionWithinFiveHoursPage"
}, {
  title: "מודיעין",
  url: "/NursingCaregiverInModiinWithinFiveHoursPage"
}, {
  title: "הרצליה",
  url: "/NursingCareProviderInHerzliyaWithinFiveHoursPage"
}, {
  title: "נתניה",
  url: "/SeoPagesForNursingCareProviderInJerusalemHaifaPetahTikvaAndNetanyaPage"
}, {
  title: "חולון",
  url: "/NursingCareInCityImmediateSolutionWithinFiveHoursPage"
}];
const locations2 = [{
  title: "בת ים",
  url: "/NursingCaregiverInCityImmediateSolutionWithinHoursPage"
}, {
  title: "גבעתיים",
  url: "/NursingCareInRamatGanWithinHoursPage"
}, {
  title: "רעננה",
  url: "/NursingCareProviderInKfarSabaWithinFiveHoursPage"
}, {
  title: "כפר סבא",
  url: "/NursingCareProviderInKfarSabaWithinFiveHoursPage"
}, {
  title: "הוד השרון",
  url: "/NursingCaregiverHodHasharonWithinHoursPage"
}, {
  title: "נס ציונה",
  url: "/NursingCareProviderRehovotPage"
}, {
  title: "רחובות",
  url: "/NursingCareProviderRehovotPage"
}, {
  title: "אשדוד",
  url: "/NursingCaregiverAshdodWithinHoursPage"
}, {
  title: "באר שבע",
  url: "/NursingCareProviderInBeershevaWithinHoursPage"
}, {
  title: "כל אזורי השירות",
  url: "/ServicesCitiesArticlesPage"
}];
export default function FinalCta() {
  return <section data-section-id="260389" id="צרו-קשר-עכשיו-מטפל-סיעודי-בחיפה" className="bg-primary text-primary-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-primary-foreground">
            זקוקים למטפל סיעודי באופן מיידי?
          </h2>
          <p className="font-default text-lg md:text-xl text-primary-foreground/80 mb-8">
            אנחנו כאן בשבילכם עם פתרון מקצועי ומהיר תוך 5 שעות בלבד בחיפה ובכל רחבי הארץ.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="rounded-lg bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-lg">
              <Link to="/ContactPage">
                <Phone className="w-5 h-5" />
                התקשרו עכשיו
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-lg bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
              <Link to="https://wa.me/972500000000" newTab>
                <MessageCircle className="w-5 h-5" />
                WhatsApp
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 pt-12 border-t border-primary-foreground/20">
          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-primary-foreground mb-2">שירותים מובילים</h3>
            {servicesLinks.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-primary-foreground mb-2">ערים מרכזיות</h3>
            {locations1.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-primary-foreground mb-2">אזורי שירות נוספים</h3>
            {locations2.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-primary-foreground mb-2">הצטרפו לניוזלטר שלנו</h3>
            <div className="relative border-b border-primary-foreground/50 pb-2 flex items-center">
              <input type="email" placeholder="האימייל שלך" className="font-default bg-transparent border-none outline-none w-full text-sm text-primary-foreground placeholder:text-primary-foreground/50" />
              <Button variant="ghost" size="icon" className="text-primary-foreground/70 hover:text-secondary transition-colors ml-2 h-auto w-auto p-0">
                <ArrowRight className="w-4 h-4" />
                <span className="sr-only">הרשמה</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}